<style scoped>
    .image {
        margin: 10px 0;
        margin-right: 10px;
    }

    img {
        background-position: center;
        background-size: cover;
    }

    .hoverbtn {
        opacity: 0.3;
    }

    .hoverbtn:hover {
        opacity: 1;
        color: tomato;
    }
</style>
<template>
    <div>
        <div v-if="editable">
            <div v-if="multi">
                <Upload ref="uploader" :data="uploadConfig" :accept="accept" :max-size="maxsize" :show-upload-list="false" :before-upload="beforeUpload" :on-success="imageUploadSuccess" :on-progress="imageProgress" multiple action="//upload.qiniup.com/" style="margin-bottom: 0;">
                    <div style="display: flex;flex-wrap: wrap;">
                        <div v-for="(image,index) in result" :key="index">
                            <!-- <div style="position: absolute;right: 4px;top: -4px;z-index: 2;" class="hover hoverbtn">
                                <Icon type="ios-close-circle" />
                            </div> -->
                            <Poptip trigger="hover" transfer>
                                <div slot="content">
                                    <a class="hoverbtn" style="margin-right: 16px;color: tomato;" @click="toView(index)">查看</a>
                                    <a class="hoverbtn" style="margin-right: 16px;color: tomato;" @click="moveUp(index)">前移</a>
                                    <a class="hoverbtn" style="margin-right: 16px;color: tomato;" @click="moveDown(index)">后移</a>
                                    <a class="hoverbtn" style="color: tomato;" @click="removeItem(index)">删除</a>
                                </div>
                                <img v-if="type=='image'" class="hover image" :src="image.url + '?imageView2/1/w/100/h/100'" style="width:32px;height:32px;;border-radius: 4px;display: block;" @click="toUpload(index)">
                                <img v-if="type=='video'" class="hover image" :src="image.url + '?vframe/jpg/offset/1'" style="width:32px;height:32px;;border-radius: 4px;display: block;" @click="toUpload(index)">
                            </Poptip>
                        </div>
                        <Button v-if="!max || result.length<max" type="dashed" class="image" style="height:32px;width: 32px;border-radius: 4px;border:1px dashed #ddd;color:#aaa;display: flex;align-items: center;justify-content: center;color:#20bf64;margin-bottom: 10px;" @click="toUpload()">
                            <Icon type="ios-add" size="32" />
                        </Button>
                    </div>
                </Upload>
            </div>
            <div v-else>
                <Upload ref="uploader" :data="uploadConfig" :accept="accept" :max-size="maxsize" :show-upload-list="false" :on-success="imageUploadSuccess" :on-progress="imageProgress" multiple action="//upload.qiniup.com/" style="margin-bottom: 0;">
                    <div v-if="result">
                        <Poptip trigger="hover" transfer>
                            <div slot="content">
                                <a class="hoverbtn" style="color: tomato;" @click="removeItem">删除</a>
                            </div>
                            <img v-if="type=='image'" class="hover" :src="result.url + '?imageView2/1/w/100/h/100'" style="width:32px;height:32px;display: block;;border-radius: 4px;" @click="toUpload()">
                            <img v-if="type=='video'" class="hover" :src="result.url + '?vframe/jpg/offset/1'" style="width:32px;height:32px;display: block;;border-radius: 4px;" @click="toUpload()">
                        </Poptip>
                    </div>
                    <Button v-else type="dashed" style="height:32px;width: 32px;border-radius: 4px;border:1px dashed #ddd;color:#aaa;display: flex;align-items: center;justify-content: center;color:#20bf64;" @click="toUpload()">
                        <Icon type="ios-add" size="32" />
                    </Button>
                </Upload>
            </div>
        </div>
        <div v-else>
            <div style="display: flex;flex-wrap: wrap;" v-if="multi">
                <img class="image" v-for="(image,index) in result" :key="index" :src="image.url + '?imageView2/1/w/100/h/100'" @click="openImage(image.url)" style="width:32px;height:32px;border-radius: 4px;display: block;">
            </div>
            <div v-else>
                <img v-if="result.type=='image'" :src="result?(result.url + '?imageView2/1/w/100/h/100'):''" @click="openImage(result?result.url:'')" style="width:32px;height:32px;display: block;;border-radius: 4px;">
                <img v-if="result.type=='video'" :src="result?(result.url + '?vframe/jpg/offset/1'):''" @click="openImage(result?result.url:'')" style="width:32px;height:32px;display: block;;border-radius: 4px;">
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            current: {
                type: [Object, Array],
                default: null,
            },
            multi: {
                type: Boolean,
                default: false,
            },
            max: {
                type: Number,
                default: null,
            },
            editable: {
                type: Boolean,
                default: true,
            },
            maxsize: {
                type: Number,
                default: 2048,
            },
            accept: {
                type: String,
                default: 'image/*',
            },
            type: {
                type: String,
                default: 'image',
            },
        },
        data() {
            return {
                loading: false,
                uploadConfig: {
                    token: null,
                    index: null,
                },
                result: this.current ? this.copy(this.current) : this.multi ? [] : null
            }
        },
        watch: {
            current(value) {
                if (value) {
                    this.result = this.copy(value)
                } else {
                    if (this.multi) {
                        this.result = []
                    } else {
                        this.result = null
                    }
                }
            }
        },
        mounted() {
            // setTimeout(() => { this.init() }, 100)
            this.init()
        },
        methods: {
            init() { },
            toUpload(index) {
                this.refreshUploadToken()
                if (index !== undefined) {
                    this.uploadConfig.index = index
                    this.uploadConfig._replace = true
                } else {
                    this.uploadConfig.index = null
                }
            },

            beforeUpload(file) {
                // let index = file.name.lastIndexOf(".")
                // let ext = file.name.substr(index + 1)
                // let suffix = ['png', 'jpg', 'PNG', 'JPG', 'GIF', 'gif']
                // if (suffix.indexOf(ext.toLowerCase()) == -1 ) {
                //     this.$Message.error({
                //         content: '上传图片必须是 JPG/PNG/GIF 格式，且不超过5MB',
                //         duration: 4,
                //         closable: true
                //     })
                //     return false
                // }
                if (file.size > this.maxsize * 1024) {
                    let maxsizeStr, filesizeStr
                    if (this.maxsize > 1024) {
                        maxsizeStr = Number(this.maxsize / 1024).toFixed(2) + 'M'
                        filesizeStr = Number(file.size / 1024 / 1024).toFixed(2) + 'M'
                    } else {
                        maxsizeStr = this.maxsize + 'K'
                        filesizeStr = Math.floor(file.size / 1024) + 'K'
                    }

                    this.$Message.error({
                        content: `${file.name}文件大小为${filesizeStr}，超过了允许的最大值${maxsizeStr}`,
                        duration: 0,
                        closable: true,
                    })
                }
            },
            imageUploadSuccess(res, file) {
                file.url = 'http://igyl.weizhilian.com/' + res.key
                let image = { url: file.url, width: res.width, height: res.height, color: res.color }
                if (this.multi) {
                    if (this.uploadConfig._replace) {
                        this.uploadConfig._replace = false
                        this.result.splice(this.uploadConfig.index, 1)
                    }
                    if (this.max && this.result.length >= this.max) {
                        this.$Message.error({
                            content: `最多只能上传${this.max}张图片`,
                            duration: 4,
                            closable: true
                        })
                        return
                    }
                    if (this.uploadConfig.index !== null) {
                        this.result.splice(this.uploadConfig.index, 0, image)
                    } else {
                        this.result.push(image)
                    }
                } else {
                    this.result = image
                }
                this.loading = false
                this.$emit('confirm', this.result)
            },
            imageProgress(res, file) {
                if (!file) { return }
                this.loading = true
            },
            refreshUploadToken() {
                this.loadUploadToken((token) => {
                    this.uploadConfig.token = token
                })
            },
            toView(index) {
                this.openImage(this.result[index].url)
            },
            openImage(url) {
                window.open(url)
            },
            moveUp(index) {
                if (index == 0) { return }
                let temp = this.result[index - 1]
                this.result[index - 1] = this.result[index]
                this.result[index] = temp
                this.$emit('confirm', this.result)
            },
            moveDown(index) {
                if (index == this.result.length - 1) { return }
                let temp = this.result[index + 1]
                this.result[index + 1] = this.result[index]
                this.result[index] = temp
                this.$emit('confirm', this.result)
            },
            removeItem(index) {
                if (this.multi) {
                    this.result.splice(index, 1)
                } else {
                    this.result = null
                }
                this.$emit('confirm', this.result)
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/common/Uploader.vue?34527c22